"use client";

import { useEffect } from "react";

import { track } from "./core";

export const usePageTracking = (pathname: string, title?: string): void => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    track({
      name: "page_view",
      params: {
        page_path: pathname,
        page_title: title ?? document.title,
        page_location: window.location.href
      }
    });
  }, [pathname]);
};

export const useInteractionTracking = () => {
  const trackClick = (viewLocation: string): void => {
    track({
      name: "engagement",
      params: { action: "click", view_location: viewLocation }
    });
  };

  const trackHover = (viewLocation: string): void => {
    track({
      name: "engagement",
      params: { action: "hover", view_location: viewLocation }
    });
  };

  return { trackClick, trackHover };
};

export const useFormTracking = (formName: string) => {
  const trackFormStart = (): void => {
    track({ name: "form_start", params: { form_name: formName } });
  };

  const trackFormSubmit = (success: boolean): void => {
    track({ name: "form_submit", params: { form_name: formName, success } });
  };

  const trackFormFieldFocus = (fieldName: string): void => {
    track({
      name: "form_focus",
      params: { form_name: formName, field_name: fieldName }
    });
  };

  return { trackFormStart, trackFormSubmit, trackFormFieldFocus };
};
